export const VIEWPORT_HEIGHT = '100vh';
export const HEADER_FOOTER_HEIGHT = '64px';
